<template>
  <div style="margin-top: 2rem">
    <Toast position="top-right" :baseZIndex="99" />
    <div
      class="card card-custom gutter-b card-collapsed"
      data-card="false"
      id="cardFiltrosAgenda"
    >
      <div class="card-header" @click="cardFiltrosAgenda.toggle()">
        <div class="card-title mb-0">
          <h5 class="card-label mb-0">Filtros</h5>
        </div>
        <div class="card-toolbar">
          <a
            class="btn btn-icon btn-sm btn-light-primary mr-1 card-button-collapse"
          >
            <i class="ki ki-arrow-up icon-nm"></i>
          </a>

          <a
            class="btn btn-sm btn-light-warning mr-1 font-weight-bold"
            @click.stop="buscarEventos(undefined)"
          >
            Filtrar
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-5">
            <b-form-group>
              <label>Regras</label>
              <pv-multiselect
                class="form-control"
                emptyFilterMessage="Não existe regras cadastradas"
                filter
                optionLabel="mar_nome"
                :options="regras"
                placeholder="Todas"
                v-model="filtroRegraSelecionada"
                optionValue="modelo_agenda_regra_id"
              >
                <template #option="slotProps">
                  <div class="d-flex align-items-center">
                    <div
                      class="ml-1"
                      :style="`border-radius: 50%; width: 10px; height: 10px; background-color: ${slotProps.option.mar_cor};`"
                    />
                    <span class="ml-3">{{ slotProps.option.mar_nome }}</span>
                  </div>
                </template>
              </pv-multiselect>
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group>
              <label>Status</label>
              <pv-multiselect
                class="form-control"
                emptyFilterMessage="Não existe regras cadastradas"
                filter
                optionLabel="acs_status"
                optionValue="agenda_calendario_status_id"
                :options="filtroStatus"
                placeholder="Todos"
                v-model="filtroStatusSelecionado"
              />
            </b-form-group>
          </div>
          <div class="col-3">
            <b-form-group>
              <label>Sincronia</label>
              <pv-multiselect
                class="form-control"
                emptyFilterMessage="Não existe sincronia cadastradas"
                filter
                optionLabel="descricao"
                optionValue="codigo"
                :options="filtroSincronia"
                placeholder="Todos"
                v-model="filtroSincroniaSelecionado"
              />
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-custom mt-4">
      <div class="card-header">
        <div class="card-title">
          <h5 class="card-label">Calendário</h5>
        </div>
        <div class="card-toolbar">
          <!-- ROTINA DE SINCRONIZAÇÃO - ABORTADA POR HORA -->
          <!-- <button
            type="button"
            class="btn btn-success font-weight-bold mr-2"
            @click="sincronizarEventos()"
          >
            <i class="fa fa-arrows-rotate"></i> Sincronizar
          </button> -->
          <!-- <button
            type="button"
            class="btn btn-primary font-weight-bold"
            @click="formularioEvento()"
          >
            <i class="fa fa-plus"></i> Adicionar Evento
          </button> -->
          <div class="d-flex align-items-center">
            <Checkbox
              class="mr-2"
              id="por-data"
              :value="true"
              v-model="modoExibicaoDataCadastro"
            />
            <label for="por-data" class="mb-0"
              >Exibir por data de cadastro</label
            >
          </div>
        </div>
      </div>
      <div class="card-body">
        <b-overlay :show="carregandoAgenda && !isAutoUpdate" rounded="sm">
          <b-alert
            :show="modoExibicaoDataCadastro.some((item) => item)"
            variant="warning"
            class="text-dark"
          >
            Você está visualizando os agendamentos pela
            <b>data em que foram solicitados</b>,
            <b>e não pela data marcada para o atendimento</b>. Esse modo ajuda a
            organizar e aprovar os pedidos de forma mais rápida.<br />
            <span
              @click.prevent="modoExibicaoDataCadastro = []"
              class="cursor-pointer"
              style="color: #004995"
            >
              Se quiser desativar essa visualização, clique aqui.
            </span>
          </b-alert>

          <div class="calendar-wrapper" style="position: relative">
            <div
              v-if="mostrarMenuOrdenacao && agendaExibicao == 'timeDezDias'"
              class="sort-menu-overlay"
            >
              <div class="dropdown-header px-3 text-dark">Ordenar por</div>

              <button
                type="button"
                class="sort-menu-item"
                :class="{ active: ordemAgendamentos === 'desc' }"
                @click="definirOrdemAgendamentos('desc')"
              >
                <span>Data: Recente primeiros</span>
                <i v-if="ordemAgendamentos === 'desc'" class="fas fa-check"></i>
              </button>

              <button
                type="button"
                class="sort-menu-item"
                :class="{ active: ordemAgendamentos === 'asc' }"
                @click="definirOrdemAgendamentos('asc')"
              >
                <span>Data: Mais antigos primeiro</span>
                <i v-if="ordemAgendamentos === 'asc'" class="fas fa-check"></i>
              </button>
            </div>

            <FullCalendar
              id="calendar-container"
              style="height: 300px"
              :options="calendarOptions"
              ref="calendario"
            >
            </FullCalendar>

            <div
              v-if="carregandoMais"
              class="d-flex justify-content-center align-items-center p-2"
              style="
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.95);
                z-index: 2000;
                border-top: 1px solid #eee;
              "
            >
              <div class="text-center">
                <div
                  class="spinner-border spinner-border-sm text-primary mr-2"
                  role="status"
                  aria-hidden="true"
                ></div>
                <small>Carregando mais agendamentos...</small>
              </div>
            </div>
          </div>
        </b-overlay>

        <div class="p-2 bg-gray-200 mt-4 p-4 rounded">
          <p class="font-weight-bolder">Legenda:</p>
          <div class="row">
            <div class="col-2">
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ap.S"
              >
                <img
                  src="../../../../../assets/icons/check.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Aprovado</span>
              </div>
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ap.P"
              >
                <img
                  src="../../../../../assets/icons/check-sync.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Aprovação pendente</span>
              </div>
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ap.E"
              >
                <img
                  src="../../../../../assets/icons/check-erro.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Aprovado com erro</span>
              </div>
            </div>
            <div class="col-2">
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ca.S"
              >
                <img
                  src="../../../../../assets/icons/x.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Cancelado</span>
              </div>
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ca.P"
              >
                <img
                  src="../../../../../assets/icons/x-sync.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Cancelamento pendente</span>
              </div>
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.ca.E"
              >
                <img
                  src="../../../../../assets/icons/x-erro.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Cancelamento com erro</span>
              </div>
            </div>
            <div class="col-2">
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.no"
              >
                <img
                  src="../../../../../assets/icons/new.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Novo Agendamento</span>
              </div>
              <div
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                :title="textoTips.re"
              >
                <img
                  src="../../../../../assets/icons/refused.svg"
                  style="width: 32px; height: 32px"
                />
                <span class="ml-3">Recusado</span>
              </div>
              <div
                v-if="agendaExibicao == 'timeDezDias'"
                class="d-flex align-items-center"
                data-toggle="tooltip"
                data-placement="top"
                title="Existem arquivos anexados a este agendamento"
              >
                <img
                  src="../../../../../assets/icons/paperclip.svg"
                  style="
                    width: 23px;
                    height: 23px;
                    color: #808080;
                    margin-left: -8px;
                  "
                  class="m-2"
                />
                <span class="ml-2">Anexo</span>
              </div>
            </div>
            <div class="col"></div>
          </div>
        </div>
      </div>
    </div>

    <modal-evento
      ref="mdlEvento"
      @eventoCadastrado="adicionarEvento"
      @atualizar="buscarEventos(null, false)"
      @toast="addToast"
      :regras="regras"
    ></modal-evento>

    <modal-detalhes-evento
      ref="mdlDetalheEvento"
      :evento="eventoSelecionado"
      @editarEvento="editarEvento"
      @atualizar="buscarEventos(null, false)"
      @eventoExcluido="removerEvento"
      @eventoAtualizado="buscarEventos"
      @toast="addToast"
      :conta="conta"
    ></modal-detalhes-evento>

    <modal-exportar-csv ref="mdlExportarCsv"></modal-exportar-csv>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Checkbox from "primevue/checkbox";

import tippy, { hideAll, followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import moment from "moment";

import ModalEvento from "./ModalEvento";
import ModalDetalhesEvento from "./ModalDetalhesEvento";
import ModalExportarCsv from "./ModalExportarCsv";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module";
import config from "@/core/config/layout.config.json";
import KTCard from "@/assets/js/components/card.js";

import Toast from "primevue/toast";

export default {
  name: "agenda",

  components: {
    FullCalendar,
    ModalEvento,
    ModalDetalhesEvento,
    ModalExportarCsv,
    Toast,
    Checkbox
  },

  data() {
    return {
      temIdECarregou: false,
      calendarOptions: {
        locale: ptBrLocale,
        plugins: [
          interactionPlugin,
          bootstrapPlugin,
          timeGridPlugin,
          listPlugin
          // DayGridPlugin
        ],
        headerToolbar: {
          left: "prev,next today exportarCsv",
          center: "title",
          right: "ordenarAgendamentos timeGridWeek,timeGridDay,timeDezDias"
        },
        customButtons: {
          ordenarAgendamentos: {
            bootstrapFontAwesome: "fa-up-down",
            hint: "Abrir opções de ordenação",
            click: () => this.toggleMenuOrdenacao()
          },
          exportarCsv: {
            bootstrapFontAwesome: "fa-file-csv",
            hint: "Exportar Agendamentos",
            click: () => this.abrirExportarCsv()
          }
        },
        views: {
          timeDezDias: {
            type: "list",
            duration: { days: 7 },
            buttonText: "Lista"
          }
        },
        height: 800,
        navLinks: true,
        eventLimit: true,
        themeSystem: "bootstrap",
        initialView: "timeDezDias",
        selectMirror: true,
        dayMaxEvents: true,
        slotMinTime: "05:00:00",
        slotMaxTime: "21:00:00",
        weekends: true,
        eventOrder: "start,-duration,allDay,title",
        eventOrderStrict: false,
        events: [],
        nowIndicator: true,
        eventClick: this.detalheEvento,
        datesSet: this.buscarEventos,
        eventDidMount: this.showPopup,
        eventContent: (eventInfo) => {
          this.$nextTick(() => {
            this.agendaExibicao = eventInfo.view.type;
            this.$forceUpdate();
          });
          let jsonData = {};
          try {
            jsonData = eventInfo.event.extendedProps.agc_json_data
              ? JSON.parse(eventInfo.event.extendedProps.agc_json_data)
              : {};
          } catch (e) {
            jsonData = {};
          }
          return {
            html: `
            ${
              this.agendaExibicao != "timeDezDias"
                ? `
                <div class="fc-event-main-frame">

              <div class="fc-event-title-container">
                <div class="fc-event-title fc-sticky d-flex">
                  <i class="mr-2 icon icon-size-m ${this.pegarIcone(
                    eventInfo.event.extendedProps.agenda_calendario_status_id,
                    eventInfo.event.extendedProps.agc_sincronizado
                  )}
                " style="margin-top: -4px"></i>
                  <span class="presentation-blur-target">
                    ${eventInfo.event.title}
                  </span>
                </div>
              </div>
              </div>
              `
                : `
                <td class="fc-list-event-title d-flex">
                  ${
                    // ["AP", "CA"].includes(
                    //   eventInfo.event.extendedProps.agenda_calendario_status_id
                    // ) &&
                    // ["E"].includes(
                    //   eventInfo.event.extendedProps.agc_sincronizado
                    // )
                    //   ? "<i data-toggle='tooltip' data-placement='top' title='Ocorreu um erro, vefique nos detalhes do agendamento'>❗</i>"
                    //   :
                    `<i class="mr-2 icon icon-size-m  ${this.pegarIcone(
                      eventInfo.event.extendedProps.agenda_calendario_status_id,
                      eventInfo.event.extendedProps.agc_sincronizado,
                      true
                    )}" data-toggle='tooltip' data-placement='top' title='${this.pegarTooltip(
                      eventInfo.event.extendedProps.agenda_calendario_status_id,
                      eventInfo.event.extendedProps.agc_sincronizado
                    )}'></i>`
                  }


                  ${
                    eventInfo.event.extendedProps.has_arquivos ||
                    (eventInfo.event.extendedProps.arquivos_count &&
                      eventInfo.event.extendedProps.arquivos_count > 0)
                      ? '<i class="mr-2 paperclip"></i>'
                      : ""
                  }
                  <a tabindex="0">
                    ${
                      jsonData.prestador_id_txt
                        ? `<b>PRESTADOR</b>: <span class="presentation-blur-target">${jsonData.prestador_id_txt}</span> |`
                        : ``
                    }

                    ${
                      jsonData.exame_id_txt
                        ? ` <b>EXAME</b>: ${jsonData.exame_id_txt} |`
                        : ``
                    }
                    ${
                      jsonData.cliente_id_txt
                        ? ` <b>CLIENTE:</b> <span class="presentation-blur-target">${jsonData.cliente_id_txt}</span>`
                        : ``
                    }
                  </a>
                </td>
                `
            }

             `
          };
        },
        dayHeaderContent: (args) => {
          if (args.view.type !== "timeDezDias") {
            return { html: args.text };
          }

          const date = args.date;
          const eventos = this.eventos;

          const targetDateStr = moment(date).format("YYYY-MM-DD");

          const dayEvents = eventos.filter((evento) => {
            if (!evento.agc_data_inicio) return false;
            if (this.modoExibicaoDataCadastro.some((item) => item == true)) {
              return (
                moment(evento.agc_data_cadastro).format("YYYY-MM-DD") ===
                targetDateStr
              );
            }
            return evento.agc_data_inicio === targetDateStr;
          });

          const errosEvents = dayEvents.filter((evento) => {
            return ["E"].includes(evento.agc_sincronizado);
          });

          const pendentesEvents = dayEvents.filter((evento) => {
            return ["P"].includes(evento.agc_sincronizado);
          });

          return {
            html: `
              <div class="fc-day-header-content d-flex align-items-center">
                <div class="mr-2" title="Total de eventos em ${args.text}">${
              args.text
            }</div>
                <div class="badge badge-primary badge-pill">
                  ${dayEvents.length} agendamento${
              dayEvents.length !== 1 ? "s" : ""
            } exibidos
                </div>
                <div title="Total de eventos pendentes de sincronização em ${
                  args.text
                }" class="badge badge-warning badge-pill ml-1 ${
              pendentesEvents.length === 0 ? "d-none" : ""
            }">
                  ${pendentesEvents.length} pendente${
              pendentesEvents.length !== 1 ? "s" : ""
            }
                </div>
                <div title="Total de eventos com erro de sincronização em ${
                  args.text
                }" class="badge badge-danger badge-pill ml-1 ${
              errosEvents.length === 0 ? "d-none" : ""
            }">
                  ${errosEvents.length} erro${
              errosEvents.length !== 1 ? "s" : ""
            }
                </div>
              </div>
            `
          };
        }
      },

      eventos: [],
      eventoSelecionado: {},
      eventoPopup: {},
      status: [],
      agendaExibicao: "timeDezDias",
      iniciarAtualizacaoEventos: true,
      intervaloAtualizar: null,
      filtroRegraSelecionada: [],
      filtroRegras: [],
      filtroStatusSelecionado: [],
      filtroSincroniaSelecionado: [],
      filtroSincronia: [],
      filtroStatus: [],
      cardFiltrosAgenda: null,
      regras: [],
      conta: null,
      carregandoAgenda: false,
      buscando: false,
      isAutoUpdate: false,
      currentPage: 1,
      lastPage: 1,
      carregandoMais: false,
      itemsPerPage: 50,
      eventosPorPagina: {},
      calendarScrollEl: null,
      calendarScrollHandler: null,
      menuElement: null,
      menuClickHandler: null,
      ordemAgendamentos: "asc",
      mostrarMenuOrdenacao: false,
      modoExibicaoDataCadastro: [],
      textoTips: {
        ap: {
          S: "Agendamento aprovado em nosso sistema e sincronizado com a base de dados do cliente",
          P: "Aprovado em nosso sistema, mas aguardando sincronização com a base de dados do cliente",
          E: "Aprovado em nosso sistema, mas falhou ao atualizar a base de dados do cliente"
        },
        ca: {
          S: "Agendamento cancelado em nosso sistema e sincronizado com a base de dados do cliente",
          P: "Cancelado em nosso sistema, mas aguardando sincronização com a base de dados do cliente",
          E: "Cancelado em nosso sistema, mas falhou ao atualizar a base de dados do cliente"
        },
        re: "Agendamento foi recusado e não será processado",
        no: "Novo agendamento criado, aguardando aprovação ou cancelamento"
      }
    };
  },

  mounted() {
    let newConfig = JSON.parse(JSON.stringify(config));
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Agende" },
      {
        title: "Calendário",
        route: "/painel/agende/calendario"
      }
    ]);
    this.$store.dispatch(ADD_BODY_CLASSNAME, "aside-minimize");
    newConfig.header.self.display = false;
    newConfig.subheader.display = false;
    newConfig.styleContetnt = { padding: "0" };
    newConfig.styleContainer = { "max-width": "100%", margin: 0 };
    newConfig.wrapper = { "padding-top": 0 };
    newConfig.scrollTop.self.display = false;
    newConfig.aside.self.minimize.hoverable = true;
    this.$store.dispatch(SET_LAYOUT_CONFIG, newConfig);
    moment.locale("pt-br");

    this.cardFiltrosAgenda = new KTCard("cardFiltrosAgenda");

    this.carregarRegras();
    this.carregarConta();
    setTimeout(() => {
      this.cardFiltrosAgenda.toggle();
    }, 100);

    setTimeout(() => {
      this.solicitarNotificacaoNavegador();
    }, 10000);

    this.$nextTick(() => {
      this.bindCalendarScrollListener();
    });
  },

  beforeDestroy() {
    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "aside-minimize");
    clearTimeout(this.intervaloAtualizar);
    this.unbindCalendarScrollListener();
    this.unbindMenuClickListener();
  },

  methods: {
    abrirExportarCsv() {
      const calendarApi = this.$refs.calendario?.getApi();
      let range = null;
      if (calendarApi) {
        range = {
          start: calendarApi.view.activeStart,
          end: moment(calendarApi.view.activeEnd).subtract(1, "day").toDate()
        };
      }
      const porDataCadastro = this.modoExibicaoDataCadastro.some(
        (item) => item
      );
      this.$refs.mdlExportarCsv.abrir(range, porDataCadastro);
    },
    async definirOrdemAgendamentos(ordem) {
      this.ordemAgendamentos = ordem === "desc" ? "desc" : "asc";
      this.mostrarMenuOrdenacao = false;
      this.unbindMenuClickListener();

      const calendarApi = this.$refs.calendario?.getApi();
      if (!calendarApi) return;

      await this.buscarEventos(null);
      const eventOrder =
        this.ordemAgendamentos === "desc"
          ? "-start,-duration,allDay,title"
          : "start,-duration,allDay,title";

      this.calendarOptions.eventOrder = eventOrder;
      calendarApi.setOption("eventOrder", eventOrder);
    },

    toggleMenuOrdenacao() {
      if (this.agendaExibicao !== "timeDezDias") return;

      this.mostrarMenuOrdenacao = !this.mostrarMenuOrdenacao;
      this.$nextTick(() => {
        const botao = document.querySelector(".fc-ordenarAgendamentos-button");
        if (botao) {
          botao.setAttribute("aria-pressed", String(this.mostrarMenuOrdenacao));
          botao.classList.toggle("ordenar-open", this.mostrarMenuOrdenacao);
        }

        const wrapper = document.querySelector(".calendar-wrapper");
        if (wrapper) {
          wrapper.classList.toggle("ordenar-open", this.mostrarMenuOrdenacao);
        }

        if (this.mostrarMenuOrdenacao) {
          this.posicionarMenuOrdenacao();
          this.bindMenuClickListener();
        } else {
          this.unbindMenuClickListener();
        }
      });
    },

    atualizarToolbarOrdenacao() {
      const calendarApi = this.$refs.calendario?.getApi();
      if (!calendarApi) return;

      const rightToolbar =
        this.agendaExibicao === "timeDezDias"
          ? "ordenarAgendamentos timeGridWeek,timeGridDay,timeDezDias"
          : "timeGridWeek,timeGridDay,timeDezDias";

      this.calendarOptions.headerToolbar.right = rightToolbar;
      calendarApi.setOption("headerToolbar", {
        ...this.calendarOptions.headerToolbar,
        right: rightToolbar
      });
    },

    posicionarMenuOrdenacao() {
      const botao = document.querySelector(".fc-ordenarAgendamentos-button");
      const menu = document.querySelector(".sort-menu-overlay");

      if (!botao || !menu) return;

      const botaoRect = botao.getBoundingClientRect();
      const wrapper = document.querySelector(".calendar-wrapper");
      const wrapperRect = wrapper.getBoundingClientRect();

      // Posiciona o menu logo abaixo do botão
      const top = botaoRect.bottom - wrapperRect.top + 8;
      const left = botaoRect.left - wrapperRect.left;

      menu.style.top = top + "px";
      menu.style.left = left + "px";
    },

    fecharMenuOrdenacao() {
      this.mostrarMenuOrdenacao = false;
      this.unbindMenuClickListener();
    },

    getOrderBy() {
      return this.modoExibicaoDataCadastro.some((item) => item)
        ? "agc_data_cadastro"
        : "agc_data_inicio";
    },

    getTimestampOrdenacao(evento) {
      const dataBase = this.modoExibicaoDataCadastro.some((item) => item)
        ? evento.agc_data_cadastro
        : `${evento.agc_data_inicio} ${evento.agc_hora_inicio || "00:00:00"}`;

      return moment(dataBase).valueOf();
    },

    ordenarEventosParaExibicao(eventos) {
      const direcao = this.ordemAgendamentos === "desc" ? -1 : 1;

      return [...eventos].sort((eventoA, eventoB) => {
        const diferenca =
          this.getTimestampOrdenacao(eventoA) -
          this.getTimestampOrdenacao(eventoB);

        if (diferenca !== 0) {
          return diferenca * direcao;
        }

        return String(eventoA.agenda_calendario_id || "").localeCompare(
          String(eventoB.agenda_calendario_id || "")
        );
      });
    },

    adicionarEvento(evento) {
      const calendarApi = this.$refs.calendario.getApi();

      this.removerEvento(evento.agenda_calendario_id);
      const eventoCopia = { ...evento };
      const dataInicio = this.modoExibicaoDataCadastro.some((item) => item)
        ? moment(evento.agc_data_cadastro).format("YYYY-MM-DD HH:mm:ss")
        : `${evento.agc_data_inicio} ${evento.agc_hora_inicio}`;
      const dataFim = this.modoExibicaoDataCadastro.some((item) => item)
        ? moment(evento.agc_data_cadastro).format("YYYY-MM-DD HH:mm:ss")
        : `${evento.agc_data_fim} ${evento.agc_hora_fim}`;
      calendarApi.addEvent({
        id: eventoCopia.agenda_calendario_id,
        title: `${
          eventoCopia.has_arquivos ||
          (eventoCopia.arquivos_count && eventoCopia.arquivos_count > 0)
            ? "📎 "
            : ""
        }${eventoCopia.agc_nome}`,
        start: dataInicio,
        end: dataFim,
        allDay: false,
        extendedProps: eventoCopia,
        color: eventoCopia.mar_cor
      });
    },

    formularioEvento(evento) {
      this.$refs.mdlEvento.abrir({ ...evento });
    },

    async detalheEvento(info) {
      this.eventoSelecionado = {};
      const eventId =
        info.event.id || info.event.extendedProps.agenda_calendario_id;
      try {
        const evento = await this.pegarAgendamentoPorId(eventId);
        if (evento) {
          this.eventoSelecionado = { ...evento };
          this.$refs.mdlDetalheEvento.abrir(this.eventoSelecionado);
          return;
        }
      } catch (e) {
        // se falhar, cair para abrir com extendedProps
      }

      this.eventoSelecionado = { ...info.event.extendedProps };
      this.$refs.mdlDetalheEvento.abrir(this.eventoSelecionado);
    },

    carregarConta() {
      ApiService.get("administrativo/conta/pegar").then((response) => {
        this.conta = response.data.conta;
      });
    },

    editarEvento(evento) {
      this.formularioEvento(evento ? evento : { ...this.eventoSelecionado });
      this.eventoSelecionado = {};
    },

    removerEvento(id) {
      const calendarApi = this.$refs.calendario?.getApi();
      const evento = calendarApi.getEventById(id);
      if (evento) {
        evento.remove();
      }
    },

    limparCalendario() {
      const calendario = this.$refs.calendario;
      if (!calendario) return;

      const calendarApi = calendario.getApi();
      calendarApi.getEvents().forEach((evento) => {
        evento.remove();
      });
    },

    reconstruirCalendario() {
      this.limparCalendario();

      const eventosOrdenadosPorPagina = Object.keys(this.eventosPorPagina)
        .sort((a, b) => Number(a) - Number(b))
        .reduce((lista, pagina) => {
          return lista.concat(this.eventosPorPagina[pagina] || []);
        }, []);

      this.eventos = this.ordenarEventosParaExibicao(eventosOrdenadosPorPagina);

      this.eventos.forEach((evento) => {
        this.adicionarEvento(evento);
      });

      this.$nextTick(() => {
        this.reordenarListaCalendarioNoDOM();
      });
    },

    getItemsPerPage(viewType) {
      switch (viewType) {
        case "timeDezDias":
          return 50;
        case "timeGridWeek":
        case "timeGridDay":
          return 99999;
        default:
          return 99999;
      }
    },

    normalizarEventosPayload(eventosPayload) {
      if (Array.isArray(eventosPayload)) {
        return eventosPayload;
      }

      if (eventosPayload && Array.isArray(eventosPayload.data)) {
        return eventosPayload.data;
      }

      return [];
    },

    reordenarListaCalendarioNoDOM() {
      if (this.agendaExibicao !== "timeDezDias") return;
      if (this.ordemAgendamentos !== "desc") return;

      const calendario = this.$refs.calendario?.$el;
      if (!calendario) return;

      const tbody = calendario.querySelector(".fc-list-table tbody");
      if (!tbody) return;

      const rows = Array.from(tbody.children);
      if (!rows.length) return;

      const blocos = [];
      let blocoAtual = [];

      rows.forEach((row) => {
        if (row.classList.contains("fc-list-day")) {
          if (blocoAtual.length) {
            blocos.push(blocoAtual);
          }
          blocoAtual = [row];
          return;
        }

        blocoAtual.push(row);
      });

      if (blocoAtual.length) {
        blocos.push(blocoAtual);
      }

      if (!blocos.length) return;

      const fragmento = document.createDocumentFragment();
      blocos.reverse().forEach((bloco) => {
        bloco.forEach((row) => fragmento.appendChild(row));
      });

      tbody.appendChild(fragmento);
    },

    agendarAtualizacao() {
      clearTimeout(this.intervaloAtualizar);
      this.intervaloAtualizar = setTimeout(() => {
        this.atualizarPaginasCarregadas();
      }, 60000);
    },

    async atualizarPaginasCarregadas() {
      if (this.buscando || this.carregandoMais) {
        this.agendarAtualizacao();
        return;
      }

      const calendario = this.$refs.calendario;
      if (!calendario) return;

      const calendarApi = calendario.getApi();
      this.itemsPerPage = this.getItemsPerPage(calendarApi.view.type);
      const pageCount = Math.max(this.currentPage, 1);
      const dateInfo = {
        startStr: calendarApi.formatIso(
          calendarApi.currentData.dateProfile.currentRange.start
        ),
        endStr: calendarApi.formatIso(
          calendarApi.currentData.dateProfile.currentRange.end
        )
      };

      this.isAutoUpdate = true;
      this.buscando = true;

      try {
        const respostas = await Promise.all(
          Array.from({ length: pageCount }, (_, index) => index + 1).map(
            async (page) => {
              const response = await ApiService.post(
                `agenda/calendario/listar?page=${page}`,
                {
                  dataHoraInicio: dateInfo.startStr,
                  dataHoraFim: dateInfo.endStr,
                  buscarPorDataCadastro: this.modoExibicaoDataCadastro.some(
                    (item) => item
                  ),
                  modelo_agenda_regra_id: !this.filtroRegraSelecionada.length
                    ? null
                    : this.filtroRegraSelecionada,
                  agenda_calendario_status_id: !this.filtroStatusSelecionado
                    .length
                    ? null
                    : this.filtroStatusSelecionado,
                  agc_sincronizado: !this.filtroSincroniaSelecionado.length
                    ? null
                    : this.filtroSincroniaSelecionado,
                  orderBy: this.getOrderBy(),
                  orderDirection: this.ordemAgendamentos,
                  per_page: this.itemsPerPage
                },
                null,
                false
              );

              const eventosPayload = response.data.data.eventos;
              return {
                page,
                eventos: this.normalizarEventosPayload(eventosPayload),
                currentPage:
                  eventosPayload && eventosPayload.current_page
                    ? eventosPayload.current_page
                    : page,
                lastPage:
                  eventosPayload && eventosPayload.last_page
                    ? eventosPayload.last_page
                    : page,
                status: response.data.data.status
              };
            }
          )
        );

        this.eventosPorPagina = {};
        respostas.forEach((resposta) => {
          this.eventosPorPagina[resposta.page] = resposta.eventos;
          this.currentPage = resposta.currentPage;
          this.lastPage = resposta.lastPage;
          this.status = resposta.status;
        });

        this.reconstruirCalendario();
      } finally {
        this.buscando = false;
        this.carregandoAgenda = false;
        this.carregandoMais = false;
        this.isAutoUpdate = false;
        this.agendarAtualizacao();
      }
    },

    async buscarEventos(
      dateInfo,
      showOverlay = true,
      page = 1,
      append = false
    ) {
      const calendario = this.$refs.calendario;
      if (!calendario) return;
      const calendarApi = calendario.getApi();
      this.itemsPerPage = this.getItemsPerPage(calendarApi.view.type);

      if (this.temIdECarregou == false && this.$route.query.id) {
        this.temIdECarregou = true;
        let evento = null;

        try {
          evento = await this.pegarAgendamentoPorId(this.$route.query.id);
        } catch (error) {
          // evento não encontrado,
        }

        if (evento) {
          dateInfo = {
            startStr: moment(evento.agc_data_inicio)
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ss"),
            endStr: moment(evento.agc_data_inicio)
              .endOf("day")
              .add(7, "day")
              .format("YYYY-MM-DDTHH:mm:ss")
          };
          calendarApi.gotoDate(evento.agc_data_inicio);

          this.detalheEvento({
            event: {
              extendedProps: evento
            }
          });
        }
      }

      if (!dateInfo) {
        dateInfo = {
          startStr: calendarApi.formatIso(
            calendarApi.currentData.dateProfile.currentRange.start
          ),
          endStr: calendarApi.formatIso(
            calendarApi.currentData.dateProfile.currentRange.end
          )
        };
      }

      if (showOverlay) {
        this.carregandoAgenda = true;
      }

      this.buscando = true;

      try {
        const response = await ApiService.post(
          `agenda/calendario/listar${page ? `?page=${page}` : ""}`,
          {
            dataHoraInicio: dateInfo.startStr,
            dataHoraFim: dateInfo.endStr,
            buscarPorDataCadastro: this.modoExibicaoDataCadastro.some(
              (item) => item
            ),
            modelo_agenda_regra_id: !this.filtroRegraSelecionada.length
              ? null
              : this.filtroRegraSelecionada,
            agenda_calendario_status_id: !this.filtroStatusSelecionado.length
              ? null
              : this.filtroStatusSelecionado,
            agc_sincronizado: !this.filtroSincroniaSelecionado.length
              ? null
              : this.filtroSincroniaSelecionado,
            orderBy: this.getOrderBy(),
            orderDirection: this.ordemAgendamentos,
            per_page: this.itemsPerPage
          },
          null,
          showOverlay
        );

        const eventosPayload = response.data.data.eventos;
        this.status = response.data.data.status;

        const eventos = this.normalizarEventosPayload(eventosPayload);

        this.currentPage =
          eventosPayload && eventosPayload.current_page
            ? eventosPayload.current_page
            : page;
        this.lastPage =
          eventosPayload && eventosPayload.last_page
            ? eventosPayload.last_page
            : page;

        if (!append) {
          this.eventosPorPagina = {};
        }

        this.eventosPorPagina[page] = eventos;
        this.reconstruirCalendario();
      } finally {
        this.buscando = false;
        this.carregandoAgenda = false;
        this.carregandoMais = false;
        this.agendarAtualizacao();
      }
    },

    getCalendarScrollEl() {
      const calendarRoot = this.$refs.calendario?.$el;
      if (!calendarRoot) return null;

      return (
        calendarRoot.querySelector(".fc-list .fc-scroller") ||
        calendarRoot.querySelector(".fc-scroller") ||
        calendarRoot.querySelector(".fc-scroller-liquid-absolute") ||
        calendarRoot.querySelector(".fc-scroller-harness") ||
        null
      );
    },

    bindCalendarScrollListener() {
      const scrollEl = this.getCalendarScrollEl();
      if (!scrollEl || scrollEl === this.calendarScrollEl) return;

      this.unbindCalendarScrollListener();
      this.calendarScrollEl = scrollEl;
      this.calendarScrollHandler = () => {
        if (this.buscando || this.carregandoMais) return;
        if (this.currentPage >= this.lastPage) return;

        const distanceToBottom =
          scrollEl.scrollHeight - (scrollEl.scrollTop + scrollEl.clientHeight);
        if (distanceToBottom <= 250) {
          this.carregarPaginaSeguinte();
        }
      };

      scrollEl.addEventListener("scroll", this.calendarScrollHandler, {
        passive: true
      });
    },

    unbindCalendarScrollListener() {
      if (this.calendarScrollEl && this.calendarScrollHandler) {
        this.calendarScrollEl.removeEventListener(
          "scroll",
          this.calendarScrollHandler
        );
      }
      this.calendarScrollEl = null;
      this.calendarScrollHandler = null;
    },

    bindMenuClickListener() {
      const menu = document.querySelector(".sort-menu-overlay");
      if (!menu || this.menuElement === menu) return;

      this.unbindMenuClickListener();
      this.menuElement = menu;
      this.menuClickHandler = (event) => {
        const botao = document.querySelector(".fc-ordenarAgendamentos-button");
        const sortMenu = document.querySelector(".sort-menu-overlay");

        // Verifica se o click foi fora do menu e fora do botão
        if (
          sortMenu &&
          !sortMenu.contains(event.target) &&
          (!botao || !botao.contains(event.target))
        ) {
          this.fecharMenuOrdenacao();
        }
      };

      document.addEventListener("click", this.menuClickHandler, true);
    },

    unbindMenuClickListener() {
      if (this.menuClickHandler) {
        document.removeEventListener("click", this.menuClickHandler, true);
      }
      this.menuElement = null;
      this.menuClickHandler = null;
    },

    async carregarPaginaSeguinte() {
      if (this.buscando || this.carregandoMais) return;
      if (this.currentPage >= this.lastPage) return;
      this.carregandoMais = true;
      const nextPage = this.currentPage + 1;
      await this.buscarEventos(undefined, false, nextPage, true);
      this.carregandoMais = false;
    },

    async pegarAgendamentoPorId(id) {
      let response = await ApiService.get(`agenda/calendario/pegar/${id}`);
      let evento = response.data.data.evento;

      return evento;
    },

    pegarIcone(status, sincronizado, naLista = false) {
      switch (status) {
        case "AP":
          if (sincronizado == "S") {
            return "check";
          }
          if (sincronizado == "P") {
            return "check-sync";
          }
          if (sincronizado == "E") {
            // if (naLista) return "x";
            return "check-erro";
          }
          break;
        case "CA":
          if (sincronizado == "S") {
            return "x";
          }
          if (sincronizado == "P") {
            return "x-sync";
          }
          if (sincronizado == "E") {
            return "x-erro";
          }
          break;
        case "RE":
          return "refused";
        case "NO":
          return "new";

        default:
          break;
      }
    },

    pegarTooltip(status, sincronizado) {
      switch (status) {
        case "AP":
          if (sincronizado == "S") {
            return this.textoTips.ap.S;
          }
          if (sincronizado == "P") {
            return this.textoTips.ap.P;
          }
          if (sincronizado == "E") {
            return this.textoTips.ap.E;
          }
          break;
        case "CA":
          if (sincronizado == "S") {
            return this.textoTips.ca.S;
          }
          if (sincronizado == "P") {
            return this.textoTips.ca.P;
          }
          if (sincronizado == "E") {
            return this.textoTips.ca.E;
          }
          break;
        case "RE":
          return this.textoTips.re;
        case "NO":
          return this.textoTips.no;

        default:
          break;
      }
    },

    addToast(data) {
      this.$toast.add(data);
    },

    formatarDataString(dataHora, format) {
      return moment(dataHora).format(format);
    },

    async carregarRegras() {
      let response = await ApiService.get("agenda/calendario/listar/filtros");
      const visited_rules = {};
      this.regras = Object.values(response.data.data.modelosAgendaRegra).map(
        (regra) => {
          if (visited_rules[regra.mar_nome] > 0) {
            regra.mar_nome =
              regra.mar_nome + " (" + visited_rules[regra.mar_nome] + ")";
          }
          visited_rules[regra.mar_nome] =
            (visited_rules[regra.mar_nome] || 0) + 1;
          return regra;
        }
      );

      this.filtroStatus = Object.values(response.data.data.status);
      this.filtroSincronia = Object.values(response.data.data.statusSincronia);
    },

    showPopup(info) {
      this.eventoPopup = { ...info.event.extendedProps };
      // Remove any existing tippy instance attached to this element to avoid duplicates
      if (info.el && info.el._tippy) {
        try {
          info.el._tippy.destroy();
        } catch (e) {
          // ignore destroy errors
        }
      }

      // Hide any other visible tippies before creating the new one
      try {
        hideAll();
      } catch (e) {
        // ignore hideAll errors
      }

      const content = document.createElement("div");
      content.innerHTML = `
          <div class="p-2 w-100">
            <div class="d-flex justify-content-between mb-2"">
              <div class="d-flex justify-content-center align-items-center m-1">
                <div style="border-radius: 50%; width: 11px; height: 11px; background-color: ${
                  this.eventoPopup.mar_cor
                }"></div>
                <div class="ml-2 icon ${this.pegarIcone(
                  this.eventoPopup.agenda_calendario_status_id,
                  this.eventoPopup.agc_sincronizado
                )}" style="width: 26px; height: 26px" data-toggle="tooltip" data-placement="top" title="${this.pegarTooltip(
        this.eventoPopup.agenda_calendario_status_id,
        this.eventoPopup.agc_sincronizado
      )}"></div>
              </div>
              <div>
                ${
                  this.eventoPopup.agenda_calendario_status_id == "NOVO"
                    ? `<button type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                  </svg>
                </button>`
                    : "<a></a>"
                }

              </div>
            </div>

            <div class="d-flex flex-column">
              <!-- NOME DO PACIENTE -->
              <div class="d-flex">
                <div class="d-flex align-items-center mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
                  </svg>
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <span class="fc-title presentation-blur-target" style="font-size: 0.8rem">
                    ${this.eventoPopup.agc_nome}
                  </span>
                </div>
              </div>

              <!-- HORARIO DO AGENDAMENTO -->
              <div class="d-flex mt-3 ">
                <div class="d-flex align-items-center mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-alarm" viewBox="0 0 16 16">
                    <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z"/>
                    <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z"/>
                  </svg>
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <span style="font-size: 0.8rem">
                    ${this.formatarDataString(
                      this.eventoPopup.agc_data_inicio +
                        " " +
                        this.eventoPopup.agc_hora_inicio,
                      "DD/MM/YYYY HH:mm"
                    )}
                  </span>
                </div>
              </div>

              <!-- LOCALIZAÇÃO DO AGENDAMENTO, CASO EXISTA -->
              ${
                this.eventoPopup.agc_local
                  ? `
              <div class="d-flex mt-3">
                <div class="d-flex align-items-center mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                  </svg>
                </div>
                <div class="d-flex justify-content-center">
                  <span style="font-size: 0.8rem">
                    ${this.eventoPopup.agc_local}
                  </span>
                </div>
              </div>
              `
                  : ""
              }

              <!-- DESCRIÇÃO, CASO EXISTA -->
              ${
                this.eventoPopup.agc_descricao
                  ? `
                <div class="p-2 mt-3" style="background-color: #EBEDF3; border-radius: 8px; font-size: 0.8rem; min-height: 80px">
                  ${this.eventoPopup.agc_descricao}
                </div>
              `
                  : ""
              }
            </div>
          </div>
        `;
      const button = content.querySelector("button");
      if (button) {
        button.addEventListener("click", () => {
          this.editarEvento(this.eventoPopup);
          tip.hide();
        });
      }
      let tip = tippy(info.el, {
        content: content,
        placement: "top",
        animation: "scale",
        theme: "light",
        allowHTML: true,
        arrow: true,
        delay: 2000,
        interactive: true,
        // position at the initial cursor point when opened, do not follow it
        followCursor: "initial",
        plugins: [followCursor],
        appendTo: document.querySelector("#calendar-container"),
        onHidden: (instance) => {
          try {
            instance.destroy();
          } catch (e) {
            // ignore destroy errors
          }
        }
      });
    },

    async solicitarNotificacaoNavegador() {
      const valor = await this.$notification.requestPermission();
      if (valor == "denied") {
        this.$toast.add({
          severity: "warn",
          summary: "Notificação de Agendamentos",
          detail:
            "Você ainda não permitiu as notificações de agendamento do nosso sistema. Ao fazê-lo, será informado sempre que uma nova notificação estiver disponível, garantindo que você não perca nenhuma atualização importante."
        });
      }
    }

    // ROTINA DE SINCRONIZAÇÃO - ABORTADA POR HORA
    // sincronizarEventos() {
    //   const calendarApi = this.$refs.calendario.getApi();
    //   const events = calendarApi.getEvents();
    //   events.forEach((event) => {
    //     event.remove();
    //   });

    //   ApiService.get("agenda/calendario/sincronizar-agenda-marcada").then(
    //     (response) => {
    //       const modelosAgenda = response.data.data;

    //       modelosAgenda.forEach((modeloAgenda) => {
    //         this.requisitarAgendaMarcada(modeloAgenda.id);
    //       });
    //     }
    //   );
    // },

    // requisitarAgendaMarcada(modeloAgendaRegraId) {
    //   ApiService.get(
    //     `agenda/calendario/requisitar-agenda-marcada/${modeloAgendaRegraId}`
    //   ).then((response) => {
    //     const requisicao = response.data.requisicao;

    //     this.respostaAgendaMarcada(modeloAgendaRegraId, requisicao.uid);
    //   });
    // },

    // respostaAgendaMarcada(modeloAgendaRegraId, uid) {
    //   ApiService.get(
    //     `agenda/calendario/resposta-agenda-marcada/${modeloAgendaRegraId}/${uid}`
    //   ).then((response) => {
    //     console.log(response.data);
    //   });
    // }
  },
  watch: {
    modoExibicaoDataCadastro() {
      this.buscarEventos(null);
    },

    agendaExibicao() {
      this.$nextTick(() => {
        if (this.agendaExibicao !== "timeDezDias") {
          this.mostrarMenuOrdenacao = false;

          if (this.ordemAgendamentos !== "asc") {
            this.definirOrdemAgendamentos("asc");
            return;
          }
        }

        this.atualizarToolbarOrdenacao();
        this.bindCalendarScrollListener();
      });
    }
  }
};
</script>

<style scoped>
.icon {
  /* font-family: "Font Awesome 5 Free"; */
  /* content: "\f095"; */
  display: inline;
  background-color: white;
  /* border-radius: 10px; */
  /* width: 100%; */
  width: auto;
  /* padding-right: 3px;
  vertical-align: middle;
  font-weight: 900; */
}

.icon-size-p {
  width: 16px;
  height: 16px;
}

.icon-size-m {
  width: 18px;
  height: 18px;
}

.check {
  content: url(../../../../../assets/icons/check.svg);
}

.check-sync {
  content: url(../../../../../assets/icons/check-sync.svg);
}

.check-erro {
  content: url(../../../../../assets/icons/check-erro.svg);
}

.x {
  /* content: url(../../../../../assets/icons/x.svg); */
  content: url(../../../../../assets/icons/x.svg);
}

.x-sync {
  content: url(../../../../../assets/icons/x-sync.svg);
}

.x-erro {
  content: url(../../../../../assets/icons/x-erro.svg);
}

.new {
  content: url(../../../../../assets/icons/new.svg);
}

.refused {
  content: url(../../../../../assets/icons/refused.svg);
}

.paperclip {
  content: url(../../../../../assets/icons/paperclip.svg);
}

.fc-timegrid-col-events
  > .fc-timegrid-event-harness
  .fc-timegrid-event-harness-inset {
  z-index: none !important;
}

.fc-timegrid-event-harness.fc-timegrid-event-harness-inset {
  z-index: none !important;
}

.fc .fc-toolbar-chunk .fc-exportarCsv-button {
  background-color: #472282;
  border-color: #472282;
  color: #ffffff;
}

.fc .fc-toolbar-chunk .fc-exportarCsv-button:hover,
.fc .fc-toolbar-chunk .fc-exportarCsv-button:focus {
  background-color: #381b66;
  border-color: #381b66;
  color: #ffffff;
}

.fc .fc-toolbar-chunk .fc-ordenarAgendamentos-button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border-radius: 0.65rem;
  padding: 0.55rem 0.9rem;
  background: #2f3542;
  border-color: #2f3542;
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.fc .fc-toolbar-chunk .fc-ordenarAgendamentos-button:hover,
.fc .fc-toolbar-chunk .fc-ordenarAgendamentos-button:focus {
  background: #3b4253;
  border-color: #3b4253;
  color: #ffffff;
}

.fc .fc-toolbar-chunk .fc-ordenarAgendamentos-button::after {
  margin-left: 0.4rem;
}

.calendar-wrapper {
  position: relative;
}

.sort-menu-overlay {
  position: absolute;
  z-index: 2500;
  min-width: 280px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.6rem;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  padding: 0.5rem;
}

.sort-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: transparent;
  border-radius: 0.45rem;
  padding: 0.65rem 0.75rem;
  color: #2d3748;
  font-weight: 500;
  text-align: left;
}

.sort-menu-item:hover,
.sort-menu-item.active {
  background-color: #eef4ff;
  color: #0b57d0;
}

.tippy-box {
  z-index: 9999;
}
.ui-datepicker-trigger {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background: transparent;
  border: none;
  margin: 0 !important;
  padding: 0 !important;
  height: 30px !important;
}
.ui-datepicker-trigger .input-group-addon:last-child {
  border-left: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fc-basicDay-button {
  border-radius: 0;
}
body {
  margin: 40px 10px;
  padding: 0;
  font-family: "Lucida Grande", Helvetica, Arial, Verdana, sans-serif;
  font-size: 14px;
}
#calendar {
  max-width: 900px;
  margin: 0 auto;
}
.hoverEffect {
  font-size: 29px;
  position: absolute;
  margin: 30px 55px;
  cursor: pointer;
}

[type="date"] {
  background: #fff
    url(https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/calendar_2.png)
    97% 50% no-repeat;
}
[type="date"]::-webkit-inner-spin-button {
  display: none;
}
[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0;
}

/* custom styles */
body {
  padding: 4em;
  background: #e5e5e5;
  font: 13px/1.4 Geneva, "Lucida Sans", "Lucida Grande", "Lucida Sans Unicode",
    Verdana, sans-serif;
}
label {
  display: block;
}
input {
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  background-color: #fff;
  padding: 3px 5px;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1);
  width: 190px;
}

/* TESTE */
.ui-datepicker-trigger {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background: transparent;
  border: none;
  margin: 0 !important;
  padding: 0 !important;
  height: 30px !important;
}
.ui-datepicker-trigger .input-group-addon:last-child {
  border-left: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fc-basicDay-button {
  border-radius: 0;
}
body {
  margin: 40px 10px;
  padding: 0;
  font-family: "Lucida Grande", Helvetica, Arial, Verdana, sans-serif;
  font-size: 14px;
}
#calendar {
  max-width: 900px;
  margin: 0 auto;
}
.hoverEffect {
  font-size: 29px;
  position: absolute;
  margin: 30px 55px;
  cursor: pointer;
}
</style>
